import S from 's-js'

import { EnhancedEstimate as ServerEnhancedEstimate, EnhancedEstimateOptions } from 'server/models/EnhancedEstimate';
export { EnhancedEstimateData, EnhancedEstimateOptions } from 'server/models/EnhancedEstimate';

import { GeoJSONPosition } from 'data/models/GeoJSONPosition';

export class EnhancedEstimate extends ServerEnhancedEstimate {
    constructor();
    constructor(data : EnhancedEstimateOptions);
    constructor(data : EnhancedEstimateOptions = { Id: 0 }) {
        super(data);
        this.EstimatedRoute((data.EstimatedRoute || []).map(GeoJSONPosition.fromGeoJSONData));
    }

    static update(obj : EnhancedEstimate, data : EnhancedEstimateOptions) {
        S.freeze(() => {
            super.update(obj, data);
            // EstimatedRoute is a strange field b/c it's really a data field stored as JSON
            // in the db, but for serialization we send it as a JSON array rather than a
            // JSON string containing more JSON. So our typewriter-generated model thinks of
            // it as a collection of child models and doesn't update it from its update method.
            // So override the inherited update method here.
            if (data.EstimatedRoute !== undefined) {
                obj.EstimatedRoute((data.EstimatedRoute || []).map(GeoJSONPosition.fromGeoJSONData));
            }
        });
    }
}



// WEBPACK FOOTER //
// ./data/models/EnhancedEstimate.ts